import { join, drop, split, compose } from 'ramda';

export default compose(
  join('/'),
  drop(3),
  split('/')
);
